import { defineStore } from "pinia";

export const useAppStore = defineStore('app', {
  state: () => ({
    loading: false,
    online: true,
    clusterViews: [
      {
        name: 'All Clusters',
        id: 'all',
        filter: null,
        system: true,
      },
    ],
  }),
  actions: {
    addClusterView(clusterView) {
      this.clusterViews.push(clusterView);
    },
    removeClusterView(clusterView) {
      var index = this.clusterViews
        .map((x) => {
          return x.id;
        })
        .indexOf(clusterView.id);
      this.clusterViews.splice(index, 1);
    },
    setLoading(loadingState) {
      this.loading = loadingState;
    },
    setOnline(onlineState) {
      this.online = onlineState;
    },
  },
  getters: {
    onlineStatus(state) {
      return state.online;
    },
    org: (state) => {
        return state.organization;
    },
  },
  persist: true,
});
